import './assets/css/main.css';
import { authStore } from './core/store/auth.store';
import { initializeRouter } from './core/router/router';
import { setupAudioContext } from './core/services/audio.service';
import { initializeAuthListener } from '@/core/services/auth.service';
import { notificationsService } from '@/core/services/notifications.service';
import { initHeaderProfile } from './components/header-profile/header-profile';
import { initSidebar } from './components/sidebar/sidebar';
import { initModal } from './components/modal/modal';
import { initQuetzalitoChat } from './components/quetzalito-chat/quetzalito-chat';

let isAppInitialized = false;

/**
 * Inicializa los componentes principales de la UI de la aplicación.
 */
function initializeUI(): void {
    if (isAppInitialized) return;

    const currentPath = window.location.pathname.split('?')[0].split('#')[0];
    const isAdminRoute = currentPath.startsWith('/admin/');

    if (isAdminRoute) {
        // Carga dinámica del perfil administrativo oscuro para ahorrar recursos en clientes
        import('./components/admin-profile/admin-profile').then(({ initAdminProfile }) => {
            initAdminProfile();
        }).catch(err => console.error('[Main] Fallo al cargar admin-profile:', err));
    } else {
        initHeaderProfile();
    }

    initSidebar('#sidebar-container');
    // Modal genérico para notificaciones y otros usos
    initModal();
    // Burbuja flotante de Quetzalito: vive fuera del router outlet, disponible en toda la app
    initQuetzalitoChat();

    // Event listener global para iniciar el contexto de audio
    document.body.addEventListener('click', () => {
        setupAudioContext().catch(e => console.error("Error al configurar el contexto de audio:", e));
    }, { once: true });

    isAppInitialized = true;
}

/**
 * @file src/main.ts
 * @description Punto de entrada principal de la aplicación.
 */

/**
 * Función principal para controlar el arranque de la aplicación.
 */
function main() {
    // 1. Espera a que el DOM esté completamente cargado.
    document.addEventListener('DOMContentLoaded', () => {
        
        const currentPath = window.location.pathname.split('?')[0].split('#')[0];
        const hideDashboardByDefault = currentPath === '/auth' || currentPath.startsWith('/admin/');
        
        if (hideDashboardByDefault) {
            document.body.classList.remove('page-app');
            document.body.classList.add('page-auth');
        } else {
            document.body.classList.add('page-app');
        }

        // 2. Inicializa la UI estática (Sidebar, Header).
        try {
            initializeUI();
            console.log('[Main] UI estática inicializada.');
        } catch (error) {
            console.error('[Main] Fallo crítico al inicializar la UI base.', error);
            document.body.innerHTML = '<div style="color: red; text-align: center; padding-top: 50px;">Error fatal al cargar la interfaz.</div>';
            return; // Detiene la ejecución si la UI base falla.
        }

        // 3. Inicializa el listener de autenticación.
        // Este se encargará de disparar 'auth-state-ready' cuando se resuelva el estado.
        initializeAuthListener();

        // 4. Espera la señal de que el estado de autenticación está resuelto para iniciar el router.
        window.addEventListener('auth-state-ready', () => {
            console.log('[Main] Estado de autenticación resuelto. Inicializando router...');
            initializeRouter();
            
            // 5. Inicializar el servicio de notificaciones si el usuario está autenticado
            const currentUser = authStore.getState().user;
            if (currentUser) {
                notificationsService.init().catch(error => {
                    console.error('[Main] Error inicializando servicio de notificaciones:', error);
                });
            }
        }, { once: true });
    });
}

// Inicia la aplicación.
main();
